<template>
  <div class="input-bottom-divider"></div>
</template>

<script>
export default {
  name: "InputBottomDivider",
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.input-bottom-divider {
  width: 100%;
  height: 1px;
  background-color: $aisea-light-gray;
}
</style>
